import { useAppContext } from '@contexts/app';
import { FeatureFlag } from '@root/globalTypes';
import { useGetAdmin } from '@services/panel/admins/get';
import { getUserData } from '@utils/getUserData';

export const hasFeatureFlag = (featureFlags: string[] | undefined, flag: FeatureFlag) =>
  Boolean(featureFlags?.includes(flag));

export const useFeatureFlag = (flag: FeatureFlag) => {
  const {
    admin: { data },
  } = useAppContext();
  const localAdmin = getUserData('admin');
  const { isLoading } = useGetAdmin(localAdmin?.id);

  return { enabled: hasFeatureFlag(data.featureFlags, flag), isLoading };
};
